import { COMMON_CHART_FONT_STYLES, getChartFontColor, getChartGridColor } from '../../../../utils/chart';

export const createOptions = ({ theme, data, config }) => {
  const gridColor = getChartGridColor(theme);
  const fontColor = getChartFontColor(theme);

  return {
    responsive: true,
    maintainAspectRatio: false,
    borderRadius: 8,
    elements: {
      bar: {
        borderRadius: 5,
      },
    },
    interaction: {
      mode: 'index',
      axis: 'x',
    },
    plugins: {
      legend: {
        display: config.options?.plugins?.legend?.display,
        position: 'top',
        labels: {
          color: fontColor,
          usePointStyle: true,
          boxWidth: 8,
          font: COMMON_CHART_FONT_STYLES,
          padding: 20,
          ...(config.options?.plugins?.legend?.labels ?? {}),
        },
      },
      tooltip: {
        intersect: false,
        enabled: !config.tooltip,
        external: function (context) {
          config.tooltip && getTooltipsCustomConfig(context, { config: config.tooltip, data });
        },
      },
      ...(config.datalabels ? { datalabels: { ...config.datalabels } } : {}),
      annotation: {
        annotations: (config.annotations ?? []).reduce((acc, annotation, index) => {
          acc[`line${index}`] = { ...annotation };
          return acc;
        }, {}),
      },
    },

    scales: {
      x: {
        offset: true,
        position: 'bottom',
        ticks: {
          display: config?.scales?.x?.ticks?.display ?? true,
          color: fontColor,
          font: COMMON_CHART_FONT_STYLES,
          padding: 8,
          callback: function (value) {
            const label = this.getLabelForValue(value);
            const limit = 19;
            return '     ' + (label.length <= limit ? label : label.substring(0, limit - 2) + '...');
          },
        },
        grid: {
          display: true,
          drawTicks: false,
          color: gridColor,
        },
      },
      y: {
        offset: true,
        position: 'left',
        ticks: {
          display: config?.scales?.y?.ticks?.display ?? true,
          color: fontColor,
          font: COMMON_CHART_FONT_STYLES,
          padding: 8,
        },
        grid: {
          display: true,
          drawTicks: false,
          color: gridColor,
        },
      },
    },
  };
};

const getTooltipsCustomConfig = (context, { config: configTooltip, data }) => {
  const { chart, tooltip: tooltipModel } = context;
  // Tooltip Element
  let tooltipEl = document.getElementById('chartJsVerticalBarsTooltip');

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartJsVerticalBarsTooltip';
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform', 'center');
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  // Set Content
  const index = tooltipModel.dataPoints[0].dataIndex;

  // Get the canvas bounds
  const canvasBounds = chart.canvas.getBoundingClientRect();

  // Calculate tooltip position
  const positionX = canvasBounds.left + window.scrollX + tooltipModel.caretX;
  const positionY = canvasBounds.top + window.scrollY + tooltipModel.caretY;

  if (tooltipModel.body) {
    tooltipEl.innerHTML = configTooltip.createMarkup(tooltipModel, data);
  }

  // Determine whether the bar value is positive or negative
  const isPositiveBar = data[index] >= 0;

  // Set vertical position based on bar value
  if (isPositiveBar) {
    tooltipEl.style.transform = 'translate(-50%, -100%)';
  } else {
    tooltipEl.style.transform = 'translate(-50%, 0)';
  }

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.transition = 'all .5s ease';
  tooltipEl.style.left = positionX + 'px';
  tooltipEl.style.top = positionY + 'px';
  tooltipEl.style.font = tooltipModel.options.bodyFont.string;
  tooltipEl.style.padding = tooltipModel.options.padding + 'px ' + tooltipModel.options.padding + 'px';
};
